export const adminUserFrontendPath = "/user";
export const adminUserBackendPath = "/backend/auth/user/";

export const adminUserCreateFrontendPath = "/user/create";
export const adminUserCreateBackendPath = "/backend/auth/user/create/";

export const adminUserEditFrontendPath = "/user/:id";
export const adminUserEditBackendPath = "/backend/auth/user/edit/";

export const groupFrontendPath = "/group";
export const groupBackendPath = "/backend/auth/group/";
export const groupCreateFrontendPath = "/group/create";
export const groupCreateBackendPath = "/backend/auth/group/create/";
export const groupEditFrontendPath = "/group/:id";
export const groupEditBackendPath = "/backend/auth/group/edit/";

export const adminLogFrontendPath = "/admin/log";
export const adminLogBackendPath = "backend/auth/admin/log/";

export const adminUserPermissionBackendPath = "/backend/auth/permissions/";



// WEBPACK FOOTER //
// ./src/routes/user/urls.js